import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MSAL_GUARD_CONFIG, MsalBroadcastService, MsalGuardConfiguration, MsalService } from '@azure/msal-angular';
import { TranslateService } from '@ngx-translate/core';
import { SharedService } from './services/shared.service';
import { EventMessage, EventMessageUtils, EventType, RedirectRequest } from '@azure/msal-browser';
import { filter, Subject, Subscription, takeUntil, tap } from 'rxjs';
import { environment } from './environments/environment';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit, OnDestroy {
  title = 'bo-bulgari-events';
  isIframe = false;
  loginInProgress = false;

  // ** Subscription **
  subscriptionSuccess: Subscription = new Subscription();
  subscriptionError: Subscription = new Subscription();
  subscriptionTokenSuccess: Subscription = new Subscription();
  subscriptionTokenError: Subscription = new Subscription();
  subscriptionNotAuth: Subscription = new Subscription();
  subscriptionLoginStart: Subscription = new Subscription();
  subscriptionRedirect: Subscription = new Subscription();
  // **
  readonly _destroying$ = new Subject<void>();

  constructor(
    private translate: TranslateService,
    private msalService: MsalService,
    private router: Router,
    private sharedService: SharedService,
    private broadcastService: MsalBroadcastService,
    @Inject(MSAL_GUARD_CONFIG) private msalGuardConfig: MsalGuardConfiguration
  ) { }

  ngOnInit() {

    //TODO: Gestire il flusso di MSAL come su CatalogoD (vedi test()).
    this.test();
    this.isIframe = window !== window.parent && !window.opener;
    // Remove this line to use Angular Universal
    if (!this.checkoutAccount()) {
      this.login();
    } else {
      this.getUserDetails();
      return;
    }
    this.subscriptionsHandlers();

  }


  ngOnDestroy(): void {
    if (this.subscriptionSuccess) {
      this.subscriptionSuccess.unsubscribe();
    }
    if (this.subscriptionError) {
      this.subscriptionError.unsubscribe();
    }
    if (this.subscriptionTokenSuccess) {
      this.subscriptionTokenSuccess.unsubscribe();
    }
    if (this.subscriptionTokenError) {
      this.subscriptionTokenError.unsubscribe();
    }
    if (this.subscriptionRedirect) {
      this.subscriptionRedirect.unsubscribe();
    }
    if (this.subscriptionLoginStart) {
      this.subscriptionLoginStart.unsubscribe();
    }
  }

  // MSAL
  checkoutAccount() {
    return this.msalService.instance.getAllAccounts().length > 0;
  }

  login() {
    if (!this.loginInProgress) {
      this.msalService.loginRedirect({ ...this.msalGuardConfig.authRequest, domainHint: 'bulgari.com' } as RedirectRequest);
    }
  }

  logout() {
    sessionStorage.clear();
    this.sharedService.eraseEvent();
    this.msalService.logout();
  }

  getUserDetails() {
    const account = this.msalService.instance.getAllAccounts().slice(-1)[0];
    this.sharedService.setUser(account);
    setTimeout(() => {
      const lang = this.translate.getBrowserLang();
      this.translate.setDefaultLang(lang === 'ko' ? lang : 'en');
    }, 1000);
  }

  test() {//Observer per la gestione delle varie fasi della login
    this.broadcastService.msalSubject$
      .pipe(
        tap((msg: EventMessage) => {
          this.log(msg);
          // switch (msg.eventType) {
          //   case EventType.ACQUIRE_TOKEN_FAILURE: {
          //     if (this.msalService.instance.getAllAccounts().length > 0) {
          //       this.logout();
          //     } else {
          //       this.msalService.loginRedirect({ ...this.msalGuardConfig.authRequest, domainHint: 'bulgari.com' } as RedirectRequest);
          //     }
          //     break;
          //   }
          // }
        }),
        takeUntil(this._destroying$)
      )
      .subscribe();
  }

  log(msg: EventMessage) {
    console.log(
      `%cMSAL%c ► %c${msg.eventType.split(":")[1].toUpperCase()}`,
      "color: darkorange; font-weight: bold;",
      "color: gold;",
      "",
    );
  }

  private subscriptionsHandlers() {
    // * HANDLE_REDIRECT_START
    this.broadcastService.msalSubject$
      .pipe(
        filter(
          (msg: EventMessage) =>
            msg.eventType === EventType.HANDLE_REDIRECT_START
        ),
        takeUntil(this._destroying$)
      )
      .subscribe((result) => {
        this.loginInProgress = true;
        console.log('HANDLE_REDIRECT_START', result);
      });
    // **
    // * HANDLE_REDIRECT_END
    this.subscriptionRedirect = this.broadcastService.msalSubject$
      .pipe(
        filter(
          (msg: EventMessage) => msg.eventType === EventType.HANDLE_REDIRECT_END
        ),
        takeUntil(this._destroying$)
      )
      .subscribe((result) => {
        console.log('HANDLE_REDIRECT_END', result);
      });
    // **
    // * LOGIN_START
    this.subscriptionLoginStart = this.broadcastService.msalSubject$
      .pipe(
        filter((msg: EventMessage) => msg.eventType === EventType.LOGIN_START),
        takeUntil(this._destroying$)
      )
      .subscribe((result) => {
        this.loginInProgress = true;
      });
    //*
    //* LOGIN_SUCCESS
    this.subscriptionSuccess = this.broadcastService.msalSubject$
      .pipe(
        filter(
          (msg: EventMessage) => msg.eventType === EventType.LOGIN_SUCCESS
        ),
        takeUntil(this._destroying$)
      )
      .subscribe((result) => {
        if (result) {
          this.loginInProgress = false;
          this.msalService.acquireTokenSilent({
            scopes: ['api://' + environment.backendId + '/invoke'],
          });
          window.location.reload();
        } else {
          console.log("Redirect from:", "app.component.ts - LOGIN_SUCCESS - !res ")
          this.router.navigate(['not-authorized'], {
            skipLocationChange: false
          });
        }
      });
    // *
    // * LOGIN_FAILURE
    this.subscriptionError = this.broadcastService.msalSubject$
      .pipe(
        filter(
          (msg: EventMessage) => msg.eventType === EventType.LOGIN_FAILURE
        ),
        takeUntil(this._destroying$)
      )
      .subscribe((result) => {
        this.loginInProgress = false;
        console.log('LOGIN_FAILURE:', result);
        this.msalService.loginRedirect({ ...this.msalGuardConfig.authRequest, domainHint: 'bulgari.com' } as RedirectRequest);
      });
    //*
    // * ACQUIRE_TOKEN_SUCCESS
    this.subscriptionTokenSuccess = this.broadcastService.msalSubject$
      .pipe(
        filter(
          (msg: EventMessage) =>
            msg.eventType === EventType.ACQUIRE_TOKEN_SUCCESS
        ),
        takeUntil(this._destroying$)
      )
      .subscribe((result) => {
        console.log('ACQUIRE_TOKEN_SUCCESS:', result);
        window.location.reload();
      });

    //*
    // * ACQUIRE_TOKEN_FAILURE
    this.subscriptionTokenError = this.broadcastService.msalSubject$
      .pipe(
        filter(
          (msg: EventMessage) =>
            msg.eventType === EventType.ACQUIRE_TOKEN_FAILURE
        ),
        takeUntil(this._destroying$)
      )
      .subscribe((result) => {
        console.log('ACQUIRE_TOKEN_FAILURE:', result);
        console.log("Redirect from:", "app.component.ts - ACQUIRE_TOKEN_FAILURE")
        this.router.navigate(['not-authorized'], {
          skipLocationChange: false
        });
      });
  }

}
